import { render, staticRenderFns } from "./Anniversaires.vue?vue&type=template&id=5ff739af&"
import script from "./Anniversaires.vue?vue&type=script&lang=js&"
export * from "./Anniversaires.vue?vue&type=script&lang=js&"
import style0 from "./Anniversaires.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports